<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import moment from 'moment'
import {
  authComputed,
  userListMethod,
  siteListMethod,
  meetingListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Live Class',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      title: '',
      description: '',
      startTime: '',
      endTime: '',
      date: '',
      teacherId: null,
      userError: null,
      isUserError: false,
      isLoading: false,
      show: false,
      platformId: '',
      platform: '',
      teacherList: [],
      teacherDataList: [],
      timeError: false,
      classlist: [],
      teacherClassList: [],
      collegeId: '',
      collegeClass: [],
      departmentId: null,
      departmentlist: [],
      timeError1: false,
    }
  },
  computed: {
    ...authComputed,
    ...departmentComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getTeachers()
    this.getDepartments()
    this.collegeId = this.profileData.college_id
    if (this.role === 'college') {
      this.teacherId = this.currentUser.user._id
    }
    if (this.role === 'teacher') {
      this.departmentId = this.profileData.department
      this.teacherClassList = this.profileData.collegeClass
      this.teacherId = this.currentUser.user._id
      this.getClasses()
    } else if (this.role === 'hod') {
      this.departmentId = this.profileData.department
      this.teacherId = this.currentUser.user._id
      this.getClasses()
    }
    this.fetchSiteList()
      .then((siteconfig) => {
        siteconfig.forEach((element) => {
          if (element.platform_id === this.currentUser.user.platform_id) {
            this.platformId = element.platform_id
            this.platform = element.site_name
            // this.collegeId = element.platform_id
            // this.collegeName = element.site_name
          }
        })
      })
      .catch((_error) => {})
  },
  methods: {
    ...userListMethod,
    ...siteListMethod,
    ...meetingListMethod,
    ...departmentListMethod,
    addMeetingData() {
      this.timeError = false
      this.timeError1 = false
      this.isLoading = true
      if (
        this.startTime !== '' &&
        this.endTime !== '' &&
        this.startTime > this.endTime
      ) {
        this.timeError1 = true
        this.isLoading = false
      } else {
        this.timeError1 = false
      }
      const Data = {
        title: this.title,
        description: this.description,
        start_time: this.startTime,
        end_time: this.endTime,
        date: this.date,
        teacher_id: this.teacherId,
        college_id: this.collegeId,
        department: this.departmentId,
        collegeClass: this.collegeClass,
      }
      let datetime = moment(
        `${this.date} ${this.startTime}`,
        'YYYY-MM-DD HH:mm:ss'
      ).format()
      let datetime1 = moment(
        `${this.date} ${this.endTime}`,
        'YYYY-MM-DD HH:mm:ss'
      ).format()
      const now = new Date()
      const today = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
      )
      const minDate = new Date(today)
      const d1 = new Date(moment(minDate).format())
      const d2 = new Date(datetime)
      const d3 = new Date(datetime1)
      if (d1 > d2 || d1 > d3) {
        this.timeError = true
        this.isLoading = false
      } else {
        this.timeError = false
      }
      if (!this.timeError && !this.timeError1) {
        this.addMeeting({ Data })
          .then((resp) => {
            this.isLoading = false
            this.$router.push({ name: 'meeting.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.userError = getError.message
            this.isUserError = true
            window.scrollTo(0, 0)
          })
      }
    },

    getTeachers() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'first_name',
        order: '1',
      }
      this.fetchTeacherList({ filter })
        .then((teachers) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Teacher',
            disabled: true,
          })
          teachers.docs.forEach((element) => {
            var ele = {}
            ele.text = element.first_name + ' ' + element.last_name
            ele.value = element._id
            listitems.push(ele)
            this.teacherList = listitems
          })
        })
        .catch((_error) => {})
    },

    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate())
      return minDate
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.description.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    getClasses() {
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            if (
              this.departmentId === element.department &&
              this.role !== 'teacher'
            ) {
              ele.text = element.name
              ele.value = element._id
              ele.college = element.college_id
              listitems.push(ele)
            } else if (
              this.role === 'teacher' &&
              this.teacherClassList.includes(element._id)
            ) {
              ele.text = element.name
              ele.value = element._id
              ele.college = element.college_id
              listitems.push(ele)
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Department',
            disabled: true,
          })
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="addMeetingData"
            >
              <b-form-group label="Class Title*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="title"
                  type="text"
                  placeholder="Enter Class Title"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Class Description*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="description"
                  type="text"
                  placeholder="Enter Class Description"
                  @keypress="restrictChars1($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Date*" label-for="input-1">
                <b-form-datepicker
                  id="example-datepicker"
                  v-model="date"
                  :min="getMinDate()"
                ></b-form-datepicker>
              </b-form-group>
              <b-form-group label="Class Start Time*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="startTime"
                  type="time"
                  placeholder="Enter Time"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Class End Time*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="endTime"
                  type="time"
                  placeholder="Enter Time"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="role !== 'teacher' && role !== 'hod'"
                label="Select Department*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="departmentId"
                  :options="departmentlist"
                  @change="getClasses"
                ></b-form-select>
              </b-form-group>

              <b-form-group label="Select Class*" label-for="input-1">
                <b-form-select
                  v-model="collegeClass"
                  :options="classlist"
                  multiple
                ></b-form-select>
              </b-form-group>
              <br />
              <!-- <b-form-group
                v-if="role !== 'teacher' && role !== 'hod'"
                label="Select Teacher*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="teacherId"
                  :options="teacherList"
                ></b-form-select>
              </b-form-group> -->
              <p v-if="timeError" style="color: red">Added past date/time</p>
              <p v-if="timeError1" style="color: red"
                >Please add end time greater than start time</p
              >
              <b-alert
                v-model="isUserError"
                variant="danger"
                v-html="userError"
              ></b-alert>
              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/meeting-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}

.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
